import { ArrowDownUp } from 'lucide-react';
import type { ReactNode } from 'react';

/** A form row (docs/DESIGN.md §4): label on the start side, value on the end side. */
export function Row({
  label,
  htmlFor,
  error,
  children,
}: {
  label: string;
  htmlFor?: string;
  error?: string | null;
  children: ReactNode;
}) {
  return (
    <li className="flex flex-col px-4 py-2">
      <div className="flex min-h-12 items-center justify-between gap-3">
        {htmlFor ? (
          <label htmlFor={htmlFor} className="shrink-0 text-[13px] text-muted">
            {label}
          </label>
        ) : (
          <span className="shrink-0 text-[13px] text-muted">{label}</span>
        )}
        <div className="flex min-w-0 justify-end">{children}</div>
      </div>
      {error && <p className="pb-1 text-sm text-danger">{error}</p>}
    </li>
  );
}

/** A 32px pill on `--surface-2` with a 44px touch area (docs/DESIGN.md chip button). */
export function Chip({ onClick, children }: { onClick: () => void; children: ReactNode }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="group inline-flex min-h-11 min-w-0 items-center focus-visible:outline-none"
    >
      <span className="inline-flex h-8 max-w-[14rem] items-center truncate rounded-full bg-surface-2 px-3 text-sm font-medium group-hover:bg-line group-focus-visible:outline-2 group-focus-visible:outline-accent">
        {children}
      </span>
    </button>
  );
}

/** The ⇅ button between a From and a To row: swaps the two. */
export function SwapRow({ label, onSwap }: { label: string; onSwap: () => void }) {
  return (
    <li className="flex justify-center px-4 py-0.5">
      <button
        type="button"
        onClick={onSwap}
        aria-label={label}
        title={label}
        className="flex size-11 items-center justify-center rounded-2xl text-fg hover:bg-surface-2 focus-visible:outline-2 focus-visible:outline-accent"
      >
        <ArrowDownUp aria-hidden="true" className="size-5" strokeWidth={2} />
      </button>
    </li>
  );
}
